import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET, GET_TYPES } from '@hobs/constants/phases';

class Phases extends BaseReducer {
  static defaultState = {
    phases: [],
    phaseTypes: []
  };

  constructor() {
    super(Phases.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.setPhases,
      [GET_TYPES.SUCCESS]: this.setPhaseTypes
    };
  }

  setPhases = (state, action) => {
    return Object.assign({}, state, { phases: action.response });
  };

  setPhaseTypes = (state, action) => {
    return Object.assign({}, state, { phaseTypes: action.response });
  };
}

export default new Phases().reducer;
